module.exports = __webpack_public_path__ + "static/media/timelapse_10.22553287.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_10.jpg
// module id = 970
// module chunks = 0